import { freeUserUpgradeStep } from '../utils';

export const settingsBusinessTour = {
  tourKey: 'settings_business',
  conditions: {
    orgTypes: ['business'],
    userTypes: ['admin'],
    plans: null,
  },
  steps: [
    {
      target: '[data-tour="business-profile"]',
      title: 'tours.settings-business.welcome.title',
      content: 'tours.settings-business.welcome.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="settings-tab"]',
      title: 'tours.settings-business.settings-tab.title',
      content: 'tours.settings-business.settings-tab.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="general-section"]',
      title: 'tours.account-settings-npo.general-info.title',
      content: 'tours.settings-business.general-info.content',
      placement: 'top',
    },
    freeUserUpgradeStep,
  ],
};
